import { useState, useEffect } from 'react';
import { useTheme } from '../context/theme';

export default function UpdateToast() {
  const { isDark } = useTheme();
  const [show, sS] = useState(false);
  const [reg, setReg] = useState(null);

  useEffect(() => {
    const handler = (e) => {
      sS(true);
      if (e.detail && e.detail.registration) setReg(e.detail.registration);
    };
    window.addEventListener('sw-update-ready', handler);
    return () => window.removeEventListener('sw-update-ready', handler);
  }, []);

  if (!show) return null;

  const doUpdate = () => {
    if (reg && reg.waiting) {
      reg.waiting.postMessage({ type: 'SKIP_WAITING' });
      window.location.reload();
    } else {
      window.location.reload();
    }
  };

  return (
    <div style={{
      position: 'fixed', bottom: 80, left: '50%', transform: 'translateX(-50%)', zIndex: 10000,
      padding: '12px 20px', background: 'linear-gradient(135deg,#161619,#2a2a32)',
      borderRadius: 12, boxShadow: '0 4px 20px rgba(0,0,0,0.4)',
      display: 'flex', alignItems: 'center', gap: 12, animation: 'slideUp .3s ease',
      border: '1px solid rgba(74,222,128,0.3)'
    }}>
      <span style={{ fontSize: 14, color: '#fff' }}>Update available</span>
      <button onClick={doUpdate} style={{
        background: '#4ADE80', color: '#161619', border: 'none', borderRadius: 8,
        padding: '6px 16px', fontSize: 13, fontWeight: 700, cursor: 'pointer'
      }}>Refresh</button>
      <button onClick={() => sS(false)} style={{
        background: 'none', border: 'none', color: '#ffffff80', cursor: 'pointer', fontSize: 16, padding: '0 4px'
      }}>✕</button>
    </div>
  );
}
